import {
  TerminalOutlined, ViewComfyOutlined, AspectRatioOutlined, ElectricBoltOutlined, FitScreenOutlined, PollOutlined, AnalyticsOutlined, LayersOutlined,
} from '@mui/icons-material';

export const filtersList = [
  {
    id: 1,
    title: 'Month',
    name: 'Filter',
    data: [],
  },
  {
    id: 2,
    title: 'Active Since',
    name: 'Filter',
    data: [],
  },
  {
    id: 3,
    title: 'Owner',
    name: 'Filter',
    data: [],
  },
];

export const eventSourceType = [
  { name: 'All Sources', value: '-all-', selected: true },
  { name: 'URI Only', value: 'URI', selected: false },
];

export const crudOperations = [
  { operationName: 'Inserts', value: 'Insert', selected: true }, { operationName: 'Reads', value: 'Read', selected: true },
  { operationName: 'Updates', value: 'Update', selected: true }, { operationName: 'Deletes', value: 'Delete', selected: true },
];

export const otherOperations = [
  { operationName: 'Visualforce Request', value: 'visualforcerequest', selected: true }, { operationName: 'Salesforce UI Interaction (URI)', value: 'salesforceuiinteraction', selected: true },
  { operationName: 'Apex Scheduled Job', value: 'apexscheduledjob', selected: true }, { operationName: 'Apex Batch Job', value: 'apexbatchjob', selected: true },
  { operationName: 'Apex Rest Web Service', value: 'apexrestwebservice', selected: true }, { operationName: 'Apex SOAP Web Service', value: 'apexsoapwebservice', selected: true },
  { operationName: 'API(Rest)', value: 'apirest', selected: true }, { operationName: 'API', value: 'api', selected: true }, { operationName: 'Visualforce Remotting', value: 'visualforceremotting', selected: true },
  { operationName: 'Platform Event', value: 'platformevent', selected: true }, { operationName: 'Unassociated CRUD', value: 'unassociationcrud', selected: true },
];

export const entityName = {
  NESTED_FEATURE: ['NestedFeature'],
  CUSTOM_OBJECT: ['CustomObject'],
  LIGHTNING_PAGE: ['LightingPage'],
  LIGHTNING_COMPONENT: ['LightningComponent'],
  VISUALFORCE_PAGE: ['VisualforcePage'],
  APEX_EXECUTION: ['ApexClass', 'ApexTrigger'],
  APEX_CLASS: ['ApexClass'],
  APEX_TRIGGER: ['ApexTrigger'],
  CUSTOM_INTERACTION: ['CustomInteractionLabel'],
  CRM_ANALYTICS: ['AnalyticsDashboard', 'AnalyticsLens', 'AnalyticsRecipe'],
  ANALYTICS_DASHBOARD: ['AnalyticsDashboard'],
  ANALYTICS_LENS: ['AnalyticsLens'],
  ANALYTICS_RECIPE: ['AnalyticsRecipe'],
};

export const operationTypeList = [
  {
    id: 'nestedFeatures', name: 'Nested Features', type: entityName.NESTED_FEATURE,
  },
  {
    id: 'customObject', name: 'Custom Objects', type: entityName.CUSTOM_OBJECT,
  },
  {
    id: 'lightingPages', name: 'Lighting Pages', type: entityName.LIGHTNING_PAGE,
  },
  {
    id: 'lightningComponents', name: 'Lighting Components', type: entityName.LIGHTNING_COMPONENT,
  },
  {
    id: 'visualForcePages', name: 'Visualforce Pages', type: entityName.VISUALFORCE_PAGE,
  },
  {
    id: 'apexExecutions', name: 'Apex Executions', type: entityName.APEX_EXECUTION,
  },
  {
    id: 'crmAnalytics', name: 'CRM Analytics', type: entityName.CRM_ANALYTICS,
  },
  {
    id: 'customInteraction', name: 'Custom Interaction', type: entityName.CUSTOM_INTERACTION,
  },
];

export const customEntityTypes = [
  { id: 'CustomObject', name: 'Custom Objects' },
  { id: 'LightingPage', name: 'Lighting Pages' },
  { id: 'LightningComponent', name: 'Lighting Components' },
  { id: 'VisualforcePage', name: 'Visualforce Pages' },
  { id: 'ApexExecution', name: 'Apex Executions' },
  { id: 'CRMAnalytics', name: 'CRM Analytics' },
  { id: 'CustomInteractionLabel', name: 'Custom Interaction' },
];

export const nestedFeature = {
  id: 'NestedFeature', name: 'Nested Features',
};

export const customObjectOperationTypes = ['Insert', 'Read', 'Update', 'Delete'];

export const customEntityKeys = {
  NESTED_FEATURE: 'NestedFeature',
  CUSTOM_OBJECT: 'CustomObject',
  LIGHTNING_PAGE: 'LightingPage',
  LIGHTNING_COMPONENT: 'LightningComponent',
  VISUALFORCE_PAGE: 'VisualforcePage',
  APEX_EXECUTION: 'ApexExecution',
  CUSTOM_INTERACTION: 'CustomInteractionLabel',
  CRM_ANALYTICS: 'CRMAnalytics',
};

export const customEntityChildren = {
  NestedFeature: ['NestedFeature'],
  CustomObject: ['CustomObject'],
  LightingPage: ['LightingPage'],
  LightningComponent: ['LightningComponent'],
  VisualforcePage: ['VisualforcePage'],
  ApexExecution: ['ApexClass', 'ApexTrigger'],
  CustomInteractionLabel: ['CustomInteractionLabel'],
  CRMAnalytics: ['AnalyticsDashboard', 'AnalyticsLens', 'AnalyticsRecipe'],
};

export const customEntityIcons = {
  NestedFeature: <PollOutlined />,
  CustomObject: <FitScreenOutlined />,
  LightningPage: <ViewComfyOutlined />,
  LightningComponent: <ElectricBoltOutlined />,
  VisualforcePage: <AspectRatioOutlined />,
  CustomInteractionLabel: <LayersOutlined />,
  ApexExecution: <TerminalOutlined />,
  CRMAnalytics: <AnalyticsOutlined />,
  // extra icons for specific types
  ApexClass: <TerminalOutlined />,
  ApexTrigger: <TerminalOutlined />,
  AnalyticsDashboard: <AnalyticsOutlined />,
  AnalyticsLens: <AnalyticsOutlined />,
  AnalyticsRecipe: <AnalyticsOutlined />,
};
